// Pages that use the feed pack also use stuff like MentionableComments
// So, we will import the main 'strava_with_framework' that imports
// and registers that component.
import './strava_with_framework';

import ReactComponentMounter from '../utils/react-component-mounter';

// Feed specific components:
import FeedRouter from '../components/Feed';
import FeedMediaShowCase from '../components/Feed/components/shared/media/FeedMediaShowCase';
import Activity from '../components/Feed/components/Activity';
import Post from '../components/Feed/components/Post';
import ChallengeJoin from '../components/Feed/components/ChallengeJoin';
import ClubJoin from '../components/Feed/components/ClubJoin';
import FancyPromo from '../components/Feed/components/FancyPromo';
import SimplePromo from '../components/Feed/components/SimplePromo';
import GroupActivity from '../components/Feed/components/GroupActivity';
import PerformanceGoalCreated from '../components/Feed/components/PerformanceGoalCreated';

ReactComponentMounter.register({
  Activity,
  ChallengeJoin,
  ClubJoin,
  FancyPromo,
  FeedRouter,
  FeedMediaShowCase,
  GroupActivity,
  PerformanceGoalCreated,
  Post,
  SimplePromo
});
